/* 🤖 this file was generated by script */
export const wiconShare04 = {
  name: 'share_04',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 9V3m0 0h-6m6 0l-8 8m-3-6H7.8c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C3 7.29 3 8.13 3 9.8v6.4c0 1.68 0 2.52.33 3.16a3 3 0 001.3 1.31c.65.33 1.49.33 3.17.33h6.4c1.68 0 2.52 0 3.16-.33a3 3 0 001.31-1.3c.33-.65.33-1.49.33-3.17V14"/></svg>`,
};
